export default {
	init() {
		//Checkbox form login
		if ($('#loginform').length > 0) {
			$('#loginform p.login-remember input[type="checkbox"]').after('<div></div>');
		}
	},
};


// WEBPACK FOOTER //
// ./scripts/routes/login.js